/* eslint-disable @stylistic/max-len */
import React from 'react';
import propTypes from './propTypes';

const Shallot = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="14"
    height="19"
    fill="none"
    viewBox="0 0 14 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.2744 5.7072C2.6112 7.2984 1.4856 9.2328 1.4856 11.2944C1.4856 12.1824 1.6464 12.924 1.9656 13.548C2.2848 14.172 2.7576 14.6904 3.4608 15.2016L3.8136 15.4584L3.6384 15.06C3.1992 14.028 2.976 12.7992 2.976 11.2968C2.9736 9.5928 3.2616 7.9224 4.2744 5.7072ZM6.2424 4.548C4.956 7.2024 4.4688 9.1512 4.4688 11.2944C4.4688 13.5168 5.0112 15.2424 6.036 16.2888L6.2448 16.5048V4.548H6.2424ZM9.6936 5.7072C10.7088 7.92 10.9968 9.5904 10.9968 11.2944C10.9968 12.7968 10.7736 14.028 10.3344 15.0576L10.1592 15.456L10.512 15.1992C11.2152 14.688 11.688 14.1672 12.0072 13.5456C12.3264 12.924 12.4872 12.18 12.4872 11.292C12.4824 9.2328 11.3568 7.2984 9.6936 5.7072ZM7.728 4.548V16.5048L7.9368 16.2888C8.9592 15.2424 9.504 13.5144 9.504 11.2944C9.5016 9.1512 9.0144 7.2024 7.728 4.548ZM6.984 18.456C4.4184 17.6016 2.628 16.6008 1.5264 15.4032C0.4872 14.2824 0 12.9816 0 11.2944C0 9.888 0.3672 8.592 1.1352 7.3296C1.8072 6.2112 2.6856 5.268 3.54 4.356C4.8336 2.9664 6.0576 1.6536 6.2328 0H7.7424C7.9104 1.6536 9.132 2.964 10.428 4.356C11.2824 5.268 12.1632 6.2112 12.8328 7.3296C13.6008 8.592 13.968 9.888 13.968 11.2944C13.968 12.9816 13.4808 14.2824 12.4416 15.4032C11.34 16.6008 9.5496 17.5992 6.984 18.456Z" fill="currentColor" />
  </svg>
);

Shallot.propTypes = propTypes;

export default Shallot;
